import HeaderBar from '../components/HeaderBar';
import {connect} from 'react-redux';
import { withRouter } from 'react-router';
import {signOut} from '../actions/auth';

let mapStateToProps = (state, ownProps) => {
  return {
    breadcrumbs: [],
    inResults: false,
    section: null,
    email: state.auth.email,
    name: state.auth.name,
    isAdmin: state.auth.isAdmin
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    onSignOut: () => dispatch(signOut())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeaderBar));
